import React from 'react';
import styled from 'styled-components';
import { DeviceType, ModalType } from '../../shared/enum/EnumRepository';
import { useDeviceStore } from '../../shared/store/deviceStore';
import { bottomWithSafeArea } from '../../shared/constants/safeArea';
import { useAuth } from '../../shared/hooks/useApi/useAuth';
import { useLanguageStore } from '../../shared/store/languageStore';
import { useModalStore } from '../../shared/store/portal/modalStore';
import { getModalMessage } from '../../shared/constants/modalMessages';
import createIcon from '../../asset/icon/create.png';
import UniversalIconBtn from '../../shared/component/headless/button/UniversalIconBtn';
import HintSmallWrapper from '../../shared/component/headless/button/HintSmallWrapper';

interface ExhibitionRightBottomIslandProps {
  fixed?: boolean;
}

const ExhibitionRightBottomIsland: React.FC<ExhibitionRightBottomIslandProps> = ({
  fixed = false,
}) => {
  const { deviceType } = useDeviceStore();
  const { user } = useAuth();
  useLanguageStore((s) => s.language);
  const { setStandardModal } = useModalStore();

  if (!user) return null;

  const label = getModalMessage('EXHIBITION_VENUE_REQUEST_TITLE');

  const handleRequest = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setStandardModal({
      modalType: ModalType.VENUE_REQUEST,
      title: null,
      value: null,
      handleChange: () => {},
    });
  };

  return (
    <GnbSection
      $fixed={fixed}
      $isMobile={deviceType === DeviceType.MOBILE}
      onClick={(e) => e.stopPropagation()}
    >
      <HintSmallWrapper content={label} toLeft={fixed}>
      <UniversalIconBtn
        size="small"
        border={false}
        isTransparent
        backgroundImg={createIcon}
        onClick={handleRequest}
        aria-label={label}
      />
      </HintSmallWrapper>
    </GnbSection>
  );
};

const GnbSection = styled.section<{ $fixed: boolean; $isMobile: boolean }>`
  position: ${({ $fixed }) => ($fixed ? 'fixed' : 'static')};
  bottom: ${({ $fixed, $isMobile }) => {
    if (!$fixed) return 'auto';
    return $isMobile
      ? bottomWithSafeArea('clamp(30px, 7vw, 40px)')
      : 'clamp(25px, 5vh, 50px)';
  }};
  right: ${({ $fixed, $isMobile }) => {
    if (!$fixed) return 'auto';
    return $isMobile ? 'clamp(8px, 3vw, 16px)' : 'clamp(20px, 2vw, 30px)';
  }};

  display: flex;
  align-items: center;
  z-index: 4;
`;

export default ExhibitionRightBottomIsland;
